import React, { useReducer } from "react";
import { Steps, Form } from "antd";
import { reducer, initialState } from "../hooks/modalReducer";
import Svg from "../assets/icons/icon";
// import AddPayementForm from "../AddPayment";
import { Modal } from "../core";
import styled from "styled-components";
import { MixStyle } from "../styles";
const { Step } = Steps;

const StyledStep = styled(Step).attrs((props) => ({
  bgcolor: props.bgcolor || "",
}))`
  && {
    height: 120px;
    .ant-steps-item-icon {
      background: ${(props) => props.bgcolor};
      width: 50px;
      height: 50px;
      border-radius: 22.5px;
      ${MixStyle.flexCenter};
    }
    .ant-steps-item-container .ant-steps-item-tail {
      top: 20px;
      left: 25px;
    }
    .ant-steps-item-container > .ant-steps-item-tail::after {
      background-color: #a2b6c9;
      width: 2px;
    }
    .ant-steps-item-content {
      min-height: 90px;
      ${MixStyle.Section};
      padding: 10px 30px;
    }
    .ant-steps-item-container
      > .ant-steps-item-content
      > .ant-steps-item-title {
      font-size: 20px;
      line-height: 30px;
      color: #000000;
      font-weight: unset;
    }
    .step--desc {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      color: #404e67;
      span {
        /* font-size: 14px;
        line-height: 21px;
        color: #949aa6;
        padding: 0px 10px; */
      }
    }
  }
`;
const StepsCompo = ({ createInvoice, sendInvocie, getinvoice }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [form] = Form.useForm();
  const onCreate = (values) => {
    dispatch({ type: "MODAL_VIEW", payload: false });
  };
  const oK = () => {
    form
      .validateFields()
      .then((values) => {
        form.resetFields();
        onCreate(values);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };
  const paid = (e) => {
    onCreate(e);
  };
  return (
    <Steps direction="vertical" size="small">
      <StyledStep
        bgcolor="#8FD1A8"
        title="Create Invoice"
        icon={<Svg icon="createInvoice" width={28} height={28} />}
        description={
          <div className="step--desc">
            {createInvoice}
            {/* Status: <span> Created on 23-3-2020 </span> */}
          </div>
        }
      />
      <StyledStep
        bgcolor="#FEE77A"
        title="Send Invoice"
        icon={<Svg icon="senInvoice" width={28} height={22.4} />}
        description={
          <div className="step--desc">
            {sendInvocie}
            {/* Status: <span> Created on 23-3-2020 </span> */}
          </div>
        }
      />
      <StyledStep
        bgcolor="#7194F8"
        title="Get Invoice"
        icon={<Svg icon="getInvoice" width={28} color="white" height={18.67} />}
        description={
          <div className="step--desc d-flex f-wrap v-center">
            {getinvoice}
            {/* Status: <span> Partially Paid </span>
            <Button
              bg="#D7E1EB"
              margin="10px 10px"
              width="102px"
              height="21px"
              onClick={() => {
                dispatch({
                  type: "MODAL_VIEW",
                  payload: { flag: true, modal_name: "marksAsPaid" },
                });
              }}
            >
              <Typography
                as="h6"
                fontSize="14px"
                lineHeight="21px"
                color="#3D5166"
              >
                Mark As Paid
              </Typography>
            </Button>
            <Button
              bg="#8FD1A8"
              margin="10px 10px"
              width="102px"
              height="21px"
              onClick={() => {
                dispatch({
                  type: "MODAL_VIEW",
                  payload: { flag: true, modal_name: "add_payment" },
                });
              }}
            >
              <Typography
                as="h6"
                fontSize="14px"
                lineHeight="21px"
                color="white"
              >
                Add Payment
              </Typography>
            </Button> */}
            {state.modal_name === "add_payment" ? (
              <Modal
                closable={false}
                visible={state.visible}
                onCreate={onCreate}
                okText="Add"
                onOk={oK}
                onCancel={() => {
                  dispatch({ type: "MODAL_VIEW", payload: false });
                }}
                tittle="Add Payment"
              >
                {/* <AddPayementForm form={form} /> */}
              </Modal>
            ) : state.modal_name === "marksAsPaid" ? (
              <Modal
                maxwidth="568px"
                closable={true}
                visible={state.visible}
                onCreate={onCreate}
                onOk={paid}
                okText="Yes"
                cancelText="No"
                onCancel={() => {
                  dispatch({ type: "MODAL_VIEW", payload: false });
                }}
                tittle="Are you sure you want to mark as paid this Invoice ?"
              />
            ) : (
              ""
            )}
          </div>
        }
      />
    </Steps>
  );
};

export default StepsCompo;
